export default __webpack_public_path__ + "static/media/logo-text-light.a4c08076.svg";